module.exports = __webpack_public_path__ + "img/notifications.3ad176d0.svg";